let isRequired = (attribute, input) => {
    if (input.trim().length === 0) {
        return {
            valid: false,
            message: 'This field is required'
        };
    }
    return {
        valid: true,
        message: ''
    };
};

let isWholeNumber = (attribute, input) => {
  if (input.includes('.')) {
    return {
      valid: false,
      message: 'Must be a whole number'
    };
  }
  return {
    valid: true,
    message: ''
  };
};

let maxDecimalNumber = (attribute, input) => {
  if(input.includes(".")) {
    if (input.split(".")[1].length > attribute) {
      return {
        valid: false,
        message: `Cannot have more than ${attribute} decimals`
      };
    }
  }
  return {
    valid: true,
    message: ''
  };
};

let minLength = (minimalLength, input) => {
    if (minimalLength > input.trim().length && input.length !== 0) {
        return {
            valid: false,
            message: `Must be longer than ${minimalLength}`
        };
    }
    return {
        valid: true,
        message: ''
    };
};

let maxLength = (maximalLength, input) => {
    if (maximalLength < input.trim().length) {
        return {
            valid: false,
            message: `Must be shorter than ${maximalLength}`
        };
    }
    return {
        valid: true,
        message: ''
    };
};

let minValue = (minimalValue, input) => {
    if (minimalValue > input && input.length !== 0) {
        return {
            valid: false,
            message: `Must be greater than ${minimalValue - 1}`
        };
    }
    return {
        valid: true,
        message: ''
    };
};

let maxValue = (maximalValue, input) => {
    if (parseInt(maximalValue) < parseInt(input)) {
        return {
            valid: false,
            message: `Must be less than ${parseInt(maximalValue) + 1}`
        };
    }
    return {
        valid: true,
        message: ''
    };
};

let email = (attribute, input) => {
    let validEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    if (!validEmail.test(input) && input.length !== 0) {
        return {
            valid: false,
            message: `Please enter a valid email address`
        };
    }
    return {
        valid: true,
        message: ''
    };
};

let date = (format, input) => {
    if (format !== '' && format !== true) {
        let separationCharacter = format.match(/\W/)[0],
            formatArray = format.toLowerCase().split(separationCharacter),
            inputArray = input.split(separationCharacter),
            enteredDay = inputArray[formatArray.indexOf('dd')],
            enteredMonth = inputArray[formatArray.indexOf('mm')],
            enteredYear = inputArray[formatArray.indexOf('yyyy')],
            daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        if (enteredYear % 4 === 0) daysInMonth[1]++;

        if ((inputArray.length < formatArray.length ||
            enteredYear.length !== 4 ||
            enteredMonth < 1 ||
            enteredMonth > 12 ||
            enteredDay < 1 ||
            enteredDay > daysInMonth[enteredMonth-1]) &&
            input.length !== 0
        ) {
            return {
                valid: false,
                message: `Please enter a valid date ( ${format.toUpperCase()} )`
            };
        }
        return {
            valid: true,
            message: ''
        };
    }
    else {
        let validDate =  /(^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[012])\/\d{4}$)|(^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$)/;

        if (!validDate.test(input) && input.length !== 0) {
            return {
                valid: false,
                message: `Please enter a valid date`
            };
        }
    }
    return {
        valid: true,
        message: ''
    };
};

let time = (attribute, input) => {
    let validTime = /^([01][0-9]|2[0-3]):[0-5][0-9]$/;

    if (!validTime.test(input) && input.length !== 0) {
        return {
            valid: false,
            message: `Please enter a valid time ( HH:MM )`
        };
    }
    return {
        valid: true,
        message: ''
    };
};

let url = (attribute, input) => {
    let validUrl = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

    if (!validUrl.test(input) && input.length !== 0) {
        return {
            valid: false,
            message: `Please enter a valid url`
        };
    }
    return {
        valid: true,
        message: ''
    };
};

let sameAs = (id, input) => {
    let relevantField = document.querySelector(`#${id}`);

    if ((relevantField && input !== '' && relevantField.value === input) || ( input === '' && relevantField.value === '')) {
        return {
            valid: true,
            message: ''
        };
    }
    return {
        valid: false,
        message: `Must be the same as ${relevantField.name.split('-').join(' ')}`
    };
};

let mustContain = (expression, input) => {
    let regEx = new RegExp(expression);

    if (!regEx.test(input) && input.length !== 0) {
        return {
            valid: false,
            message: `Input must contain: '${expression}'`
        };
    }
    return {
        valid: true,
        message: ''
    };
};

let canNotContain = (expression, input) => {
    let regEx = new RegExp(expression);

    if (regEx.test(input) && input.length !== 0) {
        return {
            valid: false,
            message: `Input can't contain: '${expression}'`
        };
    }
    return {
        valid: true,
        message: ''
    };
};

let validations = {
    isRequired,
    isWholeNumber,
    maxDecimalNumber,
    minLength,
    maxLength,
    minValue,
    maxValue,
    email,
    date,
    time,
    url,
    sameAs,
    mustContain,
    canNotContain
};

export default validations;


